import { CompassCardUI } from '@scale/compass-ui/types';
import {
  type UpdateProjectAggThrottleSchemaType,
  type UpdateProjectAggThrottleContext,
  UpdateProjectAggThrottleCardShared,
  UPDATE_PROJECT_AGG_THROTTLE,
} from '@scale/genai-compass-shared/cards/update_project_agg_throttle';
import { faGauge } from '@fortawesome/pro-solid-svg-icons';
import UpdateProjectAggThrottleCardComponent from './UpdateProjectAggThrottleCardComponent';

const defaultContext: UpdateProjectAggThrottleContext = {
  cardType: UPDATE_PROJECT_AGG_THROTTLE,
  columnIdWithProjectId: '',
  columnIdWithThrottleEntryId: '',
  columnIdWithThreshold: '',
  dryRun: false,
};

export const UpdateProjectAggThrottleCardInfo: CompassCardUI<
  UpdateProjectAggThrottleSchemaType,
  UpdateProjectAggThrottleContext
> = {
  ...UpdateProjectAggThrottleCardShared,
  title: 'Update Project Aggregate Throttle',
  icon: 'gauge',
  toolTip: 'Update the maxAttempts threshold on a project-aggregate throttle entry',
  defaultContext,
  showOutput: true,
  button: {
    icon: faGauge,
  },
  legacyComponent: UpdateProjectAggThrottleCardComponent,
};
